import Loadable from 'react-loadable';
import LoadingComponent from '../../common/loader/index';

export default [
    // page
    {
        path: '/file',
        exact: true,
        auth: true,
        component: Loadable({
            loader: () => import('../../pages/FileMgrContainer'),
            loading: LoadingComponent
        })
    }];
